/**
 * Main JavaScript Entry Point
 * This file imports all JavaScript modules and SCSS
 */

// Import SCSS first so it's bundled with the JS
import "../scss/main.scss";

// Initialize error boundary first
import "./error-handler.js";

// Import all modules
import "./animations.js";
import "./header.js";
import "./blog.js";
import "./slider.js";
import "./woocommerce.js";
import "./misc.js";
import "./accordion.js";

// Import and initialize Web Vitals tracking (with error handling)
// Using dynamic import wrapped in an async function to avoid top-level await
(async () => {
  try {
    const { initWebVitals } = await import("./web-vitals.js");
    if (initWebVitals) {
      initWebVitals();
    }
  } catch (error) {
    console.warn("Web Vitals not available:", error);
  }
})();
